import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class NoCacheInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const cacheBustedRequest = request.clone({
      params: request.params.append('_', new Date().valueOf().toString()),
    });

    return next.handle(cacheBustedRequest);
  }
}



// WEBPACK FOOTER //
// ./ts/app/no-cache-interceptor.ts